


































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {ChallengeSummary, submitParticipant, validateChallengeKey} from '@/services/participant-service';
import {participantVuexNamespace} from '@/store/participant/const';
import {updateAuthHeader} from '@/services/solid-api-service';

@Component
export default class SignUp extends Vue {

    @participantVuexNamespace.Getter
    protected challengeSummary!: ChallengeSummary;

    protected valid: boolean = false;
    protected loading: boolean = false;
    protected validKey: boolean = false;
    protected challengeName: string = '';

    protected firstName: string = '';
    protected firstNameRules: any[] = [
        (v: any) => !!v || 'First Name is required',
    ];

    protected lastName: string = '';
    protected lastNameRules: any[] = [
        (v: any) => !!v || 'First Name is required',
    ];

    protected emailAddress: string = '';
    protected emailAddressRules: any[] = [
        (v: any) => !!v || 'Email is required',
        (v: any) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Invalid email address',
    ];

    protected created() {
        this.validateKey();

        if (this.challengeSummary !== null) {
            this.firstName = this.challengeSummary.firstName;
            this.lastName = this.challengeSummary.lastName;
            this.emailAddress = this.challengeSummary.emailAddress;
        }
    }

    protected async validateKey() {
        try {
            this.challengeName = await validateChallengeKey(this.challengeKey);
            this.validKey = true;
        } catch (error) {
            this.validKey = false;
            this.$dialog.error({
                text: error.message,
            });
        }
    }

    protected async submit() {
        try {
            this.loading = true;
            const summary: ChallengeSummary = await submitParticipant(this.firstName, this.lastName, this.emailAddress, this.challengeKey);
            summary.firstName = this.firstName;
            summary.lastName = this.lastName;
            summary.emailAddress = this.emailAddress;
            this.saveChallengeSummary(summary);
            updateAuthHeader(summary.token);
            this.$router.push(`/${this.challengeKey}/start`);
        } catch (error) {
            this.$dialog.error({
                text: error.message,
            });
        }
        this.loading = false;
    }

    @participantVuexNamespace.Action
    protected saveChallengeSummary!: (challengeSummary: ChallengeSummary) => void;

    protected get challengeKey(): string {
        return this.$route.params.key;
    }

    @Watch('$route.params.key')
    protected onChallengeKeyChanged() {
        this.validateKey();
    }
}
